<template>
	<div class="ks-editor-form">
		<div class="ks-editor-form-body" :class="bodyClass">
			<div :class="bodySideClass">
				<slot name="left"></slot>
			</div>
			<div :class="bodySideClass">
				<slot name="right"></slot>
			</div>
		</div>

		<div class="ks-editor-form-buttons" :class="buttonsClass">
			<div class="ks-editor-form-left-buttons"><slot name="left-buttons"></slot></div>
			<div class="ks-editor-form-right-buttons"><slot name="right-buttons"></slot></div>
		</div>
	</div>
</template>

<script>
export default {
	data () {
		return {};
	},
	props: {
		"large-buttons": {
			type: Boolean,
			default: false
		},
		"column-scroll": {
			type: Boolean,
			default: false
		}
	},
	computed: {
		bodyClass () {
			return {				
				"ks-editor-form-two-columns": !!this.$slots.left && !!this.$slots.right
			}
		},
		bodySideClass () {
			return {
				"ks-editor-form-column-scroll": !!this.columnScroll
			}
		},
		buttonsClass () {
			return {
				"ks-editor-form-large-buttons": !!this.largeButtons
			}
		}
	},

}
</script>
<style>
.ks-editor-form {
	height: 100%;
	display: grid;
	overflow: hidden;
	grid-template-rows: 1fr auto;
	gap: 7px;
}
.ks-editor-form-body {
	overflow-y: auto;
}
.ks-editor-form-buttons {
	height: 40px;
	display: grid; 
  grid-template-columns: 1fr auto; 
  width: 100%;
}
.ks-editor-form-large-buttons  {
	height: 60px;
	align-items: center;
}
.ks-editor-form-two-columns {
	display: grid;
	grid-gap: 10px;
	grid-template-columns: 1fr 1fr;
}
.ks-editor-form-column-scroll {
	overflow-y: auto;
}
@media (max-width: 900px) {
	.ks-editor-form-two-columns {
		grid-template-columns: 1fr;
	}
}
</style>
